import CantileverButton from 'components/CantileverButton'
import { AssetOverviewEditorGate } from 'features/assetDatabase'
import { AssetOverviewDataContext } from 'features/assetDatabase/contexts/AssetOverviewDataLayer'
import { useRolodexEdit } from 'features/fde'
import { useGeckoPermissions } from 'features/permissions'
import React, { useContext } from 'react'
import styled from 'styled-components'
import {
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  RolodexPermissionsValues,
} from 'types'

const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.forecast.activeText};
  font-weight: 500;
  padding: 0.75rem;
`

const ErrorContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

const ErrorText = styled.p`
  margin: 0;
`

const ButtonContainer = styled.div`
  align-self: flex-start;
`

const ASSET_OVERVIEW_PERMS_LIST: RolodexPermissionsValues[] = [
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
]

interface BrokenImgErrorMessageProps {
  erroneousEntryId: string | undefined
  needsEntryDeletion: boolean
}

export const BrokenImgErrorMessage = ({
  erroneousEntryId,
  needsEntryDeletion,
}: BrokenImgErrorMessageProps) => {
  const { rolodexDelete } = useRolodexEdit()
  const { refreshThumbnails, refreshData } = useContext(
    AssetOverviewDataContext
  )
  const { permissions } = useGeckoPermissions()

  const hasAssetOverviewPermissions = ASSET_OVERVIEW_PERMS_LIST.some(
    (permission) => permissions?.has(permission)
  )

  const deleteBrokenImage = async (entryId: string) => {
    await rolodexDelete(entryId, true)
    await refreshThumbnails()
    await refreshData()
  }
  return (
    <ErrorMessage>
      {erroneousEntryId && `Error loading image with ID: ${erroneousEntryId}`}
      {needsEntryDeletion && (
        <ErrorContainer>
          <ErrorText>
            {hasAssetOverviewPermissions
              ? 'The image file appears to be broken.'
              : 'Please contact support.'}
          </ErrorText>
          <AssetOverviewEditorGate>
            <ButtonContainer>
              <CantileverButton
                danger
                onClick={() => {
                  if (erroneousEntryId) {
                    deleteBrokenImage(erroneousEntryId)
                  }
                }}>
                Delete Broken Image
              </CantileverButton>
            </ButtonContainer>
          </AssetOverviewEditorGate>
        </ErrorContainer>
      )}
    </ErrorMessage>
  )
}
